import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
    // 通过code获取微信用户信息
    login(arg) {
        return Axios({
            url: '/auth/mobileLogin',
            method: 'post',
            data: {
                ...arg,
                clientId:'428a8310cd442757ae699df5d894f051',
                grantType: 'password'
            }
        })
    },
    // 是否是默认密码
    workerisDefaultPwd() {
        return Axios({
            url: requestPrefix.centerUrl + '/worker/isDefaultPwd',
            method: 'get'
        })
    },

    // 退出登录

    logout() {
        return Axios({
            url: 'auth/logout',
            method: 'post'
        })
    },

    // 获取app下载地址
    // getAppDownload() {
    //   return Axios({
    //     url: '/project/project/mobileUrl',
    //     method: 'get'
    //   })
    // }
    // 根据Appkey获取token
    getOpenToken(data) {
      return Axios({
        url: '/auth/open/getToken',
        method: 'post',
        data
      })
    }
}



// WEBPACK FOOTER //
// ./src/api/login/index.js